"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProducts = void 0;

var _client = require("@apollo/client");

var _queries = require("../queries");

var useProducts = function useProducts(ids, variantIDs) {
  var _useQuery = (0, _client.useQuery)(_queries.GET_CAROUSEL_PRODUCTS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    variables: {
      sku: ids,
      variantSku: variantIDs
    },
    skip: !ids.length
  }),
      data = _useQuery.data;

  return {
    products: data && data.products ? data.products.items : []
  };
};

exports.useProducts = useProducts;